import { LKRoutesEnum } from 'shared/constants/routes'

import { getRouteWithPagination } from './getRouteWithPagination'

/* Заявки */
export const getOrderItemRoute = (orderId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.orders}/${orderId}`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getActivateOrderRoute = (orderId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.orders}/${orderId}/activate`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getActivateELockRoute = (orderId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.orders}/${orderId}/activate-elock`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getOrderPaymentRoute = (orderId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.orderPayment}/${orderId}`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getCreateMovingOrderRoute = (pvzId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.orderCreate}?pvzId=${pvzId}`
  return getRouteWithPagination(baseRoute, page, pageSize)
}

/* ПВЗ */
export const getPvzItemRoute = (pvzId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.pvz}/${pvzId}`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getPvzEditAreaRoute = (pvzId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.pvz}/${pvzId}/edit-area`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getPvzEditTimetableRoute = (pvzId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.pvz}/${pvzId}/edit-timetable`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getMovingPvzPageRoute = (pvzId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.pvz}/${pvzId}/moving`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getPvzSignboardRoute = (pvzId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.pvz}/${pvzId}/signboard`
  return getRouteWithPagination(baseRoute, page, pageSize)
}

/* Тикеты */
export const getTicketItemRoute = (ticketId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.tickets}/${ticketId}`
  return getRouteWithPagination(baseRoute, page, pageSize)
}

/* Сотрудники */
export const getEmployeePageRoute = (pvzId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.employees}/${pvzId}`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getAddEmployeePageRoute = (pvzId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.addEmployee}/${pvzId}`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
export const getEditEmployeePageRoute = (pvzId: number, userId: number, page?: number, pageSize?: number) => {
  const baseRoute = `${LKRoutesEnum.editEmployee}/${pvzId}/${userId}`
  return getRouteWithPagination(baseRoute, page, pageSize)
}
